import { common } from './modules/common';
common();